import Loadable from "components/Loadable";
import { lazy } from "react";

const NotificationWhatsAppLogList = Loadable(
  lazy(() => import("features/notification/logsWhatsApp/components/List"))
);

const routes = {
  path: "whatsapp",
  children: [
    {
      path: "",
      element: <NotificationWhatsAppLogList />,
    },
  ],
};

export default routes;
